import React, { useEffect, useState } from 'react';
import './App.css';
import logo from './logoejaculacaoprecoce.png'
import capa from './capaejaculacaoprecoce.png'
import seguro from './siteseguro.png'
import compra from './comprasegura.png'

function App() {
  const [largura, setLargura] = useState(0)
  const [tempoRestante, setTempoRestante] = useState('00:00:00');

  const calcularTempoRestante = () => {
    const agora = new Date();
    const meiaNoite = new Date();
    meiaNoite.setHours(24, 0, 0, 0); // hoje às 24:00

    const diffMs = meiaNoite.getTime() - agora.getTime();

    const horas = Math.floor(diffMs / (1000 * 60 * 60));
    const minutos = Math.floor((diffMs / (1000 * 60)) % 60);
    const segundos = Math.floor((diffMs / 1000) % 60);

    return `${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}:${String(segundos).padStart(2, '0')}`;
  };

  useEffect(() => {
    setLargura(window.innerWidth)
    const interval = setInterval(() => {
      setTempoRestante(calcularTempoRestante());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (

    largura <= 1024 ?
      <div className='App'>
        <header className='header'>
          <img src={logo} alt='logoMobile' />
        </header>
        <div className='containerMobile'>
          <div className='ebookMobile'>
            <img src={capa} alt='capaMobile' />
            <div className='containerColumn' >
              <p style={{ textAlign: 'center' }}>
                <strong>O Guia Definitivo da Ejaculação Precoce!</strong>
                <br /><br />
                Descubra como controlar a ejaculação precoce de forma eficaz, segura e natural com o eBook “Ejaculação Precoce: Compreensão, Causas, Sintomas e Tratamentos”. Com linguagem clara e orientações práticas, você aprenderá técnicas comprovadas, entenderá as causas do problema e conhecerá os tratamentos mais eficazes, desde exercícios comportamentais até estratégias medicamentosas e mudanças no estilo de vida. Baseado em evidências científicas e com exemplos reais de superação, este guia é seu primeiro passo rumo a uma vida sexual mais confiante, duradoura e satisfatória.
                <br /><br />
                <b>Ideal para homens de todas as idades</b>
                <br /><br />
                <b>Acesso imediato em PDF</b>
                <br /><br />
                <b>Conteúdo validado por profissionais da saúde</b>
                <br /><br />
                Adquira agora e transforme sua vida íntima com autonomia e conhecimento.
              </p>
              <div className='containerColumn' id='comprar' style={{ marginTop: 20 }}>
                <div className='containerRow'>
                  <p className='anuncio'>De</p>
                  <p className='preco'>R$59,90</p>
                </div>
                <div className='containerRow'>
                  <p className='anuncio' style={{ fontWeight: 'bold' }}>Por</p>
                  <p className='desconto'>R$39,90</p>
                </div>
                <div className='containerColumn'>
                  <p className='oferta'>Oferta para hoje!</p>
                  <p className='timer'>{tempoRestante}</p>
                  <button className='comprar' onClick={() => window.open("https://app.monetizze.com.br/checkout/DEH347364", "_blank", "noopener,noreferrer")}>Comprar Agora</button>
                </div>
              </div>
            </div>
          </div>
          <div className='containerColumn' style={{ gap: 20, marginBottom: 20 }}>
            <p className='title' style={{ marginBottom: 0 }}>Quem comprou recomenda!</p>
            <div className='depoimento'>
              <p className='nome'>João Vitor, 32 anos</p>
              <p className='texto'>“Nunca imaginei que técnicas simples pudessem trazer tanto resultado. Em menos de um mês, já senti mais controle e confiança.”</p>
            </div>
            <div className='depoimento'>
              <p className='nome'>Marcos Azevedo, 38 anos</p>
              <p className='texto'>“O conteúdo é direto, claro e respeitoso. Pela primeira vez me senti confortável lendo sobre isso.”</p>
            </div>
            <div className='depoimento'>
              <p className='nome'>Rafael Martins, 29 anos</p>
              <p className='texto'>“Estava cético no começo, mas o material é completo e bem embasado. A parte de exercícios foi o que mais me ajudou.”</p>
            </div>
            <div className='depoimento'>
              <p className='nome'>Eduardo Lima, 45 anos</p>
              <p className='texto'>“O eBook vale cada centavo. Melhor que muita consulta cara que fiz sem sucesso. Me ajudou muito!”</p>
            </div>
            <div className='depoimento'>
              <p className='nome'>Gabriel Tavares, 26 anos</p>
              <p className='texto'>“Gostei do tom acolhedor e prático. Senti que o autor entende o que a gente passa.”</p>
            </div>
            <div className='depoimento'>
              <p className='nome'>Bruno Ferreira, 36 anos</p>
              <p className='texto'>“Já tinha tentado outras abordagens, mas esse guia me deu clareza e um plano de ação. Recomendo!”</p>
            </div>
          </div>
          <div id="container-2088d0ab141ce57abfdf4f8a9c2fd551"></div>
        </div>
        <footer className='footerMobile'>
          <p>© {new Date().getFullYear()} Todos os diretos reservados.</p>
          <img src={seguro} alt='seguroMobile' />
        </footer>
      </div>
      :
      <div className='App'>
        <header className='header'>
          <img src={logo} alt='logo' />
        </header>
        <div className='container'>
          <div className='ebook'>
            <img src={capa} alt='capa' />
            <div className='containerRow'>
              <p>
                <strong>O Guia Definitivo da Ejaculação Precoce!</strong>
                <br /><br />
                Descubra como controlar a ejaculação precoce de forma eficaz, segura e natural com o eBook “Ejaculação Precoce: Compreensão, Causas, Sintomas e Tratamentos”. Com linguagem clara e orientações práticas, você aprenderá técnicas comprovadas, entenderá as causas do problema e conhecerá os tratamentos mais eficazes, desde exercícios comportamentais até estratégias medicamentosas e mudanças no estilo de vida. Baseado em evidências científicas e com exemplos reais de superação, este guia é seu primeiro passo rumo a uma vida sexual mais confiante, duradoura e satisfatória.
                <br /><br />
                <b>Ideal para homens de todas as idades</b>
                <br /><br />
                <b>Acesso imediato em PDF</b>
                <br /><br />
                <b>Conteúdo validado por profissionais da saúde</b>
                <br /><br />
                Adquira agora e transforme sua vida íntima com autonomia e conhecimento.
              </p>
              <div className='containerColumn' id='comprar'>
                <div className='containerRow'>
                  <p className='anuncio'>De</p>
                  <p className='preco'>R$59,90</p>
                </div>
                <div className='containerRow'>
                  <p className='anuncio' style={{ fontWeight: 'bold' }}>Por</p>
                  <p className='desconto'>R$39,90</p>
                </div>
                <div className='containerColumn'>
                  <p className='oferta'>Oferta para hoje!</p>
                  <p className='timer'>{tempoRestante}</p>
                  <button className='comprar' onClick={() => window.open("https://app.monetizze.com.br/checkout/DEH347364", "_blank", "noopener,noreferrer")}>Comprar Agora</button>
                </div>
              </div>
            </div>
          </div>
          <div className='containerColumn'>
            <div id="container-2088d0ab141ce57abfdf4f8a9c2fd551"></div>
            <p className='title'>Quem comprou recomenda!</p>
            <div className='containerRow' id='depoimentos'>
              <div className='depoimento'>
                <p className='nome'>João Vitor, 32 anos</p>
                <p className='texto'>“Nunca imaginei que técnicas simples pudessem trazer tanto resultado. Em menos de um mês, já senti mais controle e confiança.”</p>
              </div>
              <div className='depoimento'>
                <p className='nome'>Marcos Azevedo, 38 anos</p>
                <p className='texto'>“O conteúdo é direto, claro e respeitoso. Pela primeira vez me senti confortável lendo sobre isso.”</p>
              </div>
              <div className='depoimento'>
                <p className='nome'>Rafael Martins, 29 anos</p>
                <p className='texto'>“Estava cético no começo, mas o material é completo e bem embasado. A parte de exercícios foi o que mais me ajudou.”</p>
              </div>
              <div className='depoimento'>
                <p className='nome'>Eduardo Lima, 45 anos</p>
                <p className='texto'>“O eBook vale cada centavo. Melhor que muita consulta cara que fiz sem sucesso. Me ajudou muito!”</p>
              </div>
              <div className='depoimento'>
                <p className='nome'>Gabriel Tavares, 26 anos</p>
                <p className='texto'>“Gostei do tom acolhedor e prático. Senti que o autor entende o que a gente passa.”</p>
              </div>
              <div className='depoimento'>
                <p className='nome'>Bruno Ferreira, 36 anos</p>
                <p className='texto'>“Já tinha tentado outras abordagens, mas esse guia me deu clareza e um plano de ação. Recomendo!”</p>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <p>© {new Date().getFullYear()} Todos os diretos reservados.</p>
          <img src={seguro} alt='seguro' />
        </footer>
      </div>
  );
}

export default App;
